import { z } from "zod";
import type { Locale } from "next-intl";
import { locales } from "@/config";


export {
  DocumentMetaTs,
  type DocumentMeta,
} from "@/providers/strapi/client/types";


export const DateTimeTs = (
  z.string()
    .transform(dateString => new Date(dateString))
);


export const LocaleTs = (
  z.enum(locales) satisfies (
    z.ZodType<Locale>
  )
);


export type PageMeta = z.output<typeof PageMetaTs>;

export const PageMetaTs = z.object({
  id: z.int(),
  pageTitle: z.string().optional(),
  pageDescription: z.string().optional(),
  ogType: z.string().nullable().optional(),
});


export type StrapiImage = z.output<typeof ImageTs>;

export const ImageTs = z.object({
  ext: z.string(), // .jpg
  url: z.string(), // https://...
  hash: z.string(), // slug_with_underscores
  mime: z.string(), // <mimetype>
  name: z.string(), // slug-with-dashes
  size: z.number(), // <kB>
  width: z.int(),
  height: z.int(),
  isUrlSigned: z.boolean(),
  sizeInBytes: z.int().optional(), // bytes
});


export const SlugTs = z.string().refine(slug => slug === slug.toLowerCase(), {
  error: "A slug must NOT contain uppercase letters",
});
